// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"b6fa05fe","422":"ad4475da","426":"681a60bd","779":"198d920b"}[chunkId] + ".chunk.js";
};